import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import './OwnerDetails.css';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import ProfileImg from '../../../src/assets/images/profile/user-1.jpg';
import TableCells from 'src/components/Tables/TableCells';
import TextInputs from 'src/components/inputs/TextInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';
export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

const initialUpdatedData = {
  activeDuration: 0,
  activeDurationType: 'Months',
};

const activeDurationTypeMenuOptions = [
  { placeholder: 'Days', value: 'Days' },
  { placeholder: 'Months', value: 'Months' },
];

const OwnerDetails = () => {
  const [statusLoading, setStatusLoading] = useState(false);
  const [data, setData] = useState({});
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [updateFormData, setUpdateFormData] = useState(initialUpdatedData);
  const [loading, setLoading] = useState(true);

  const { fetchAOwner, changeStatus, setShowMessage, deleteBranch, updateBranchSubscription } = useMain();

  const { id } = useParams();

  const naviage = useNavigate();

  const handleChangeStatus = async (status) => {
    try {
      setStatusLoading(true);
      const res = await changeStatus(id, { status });
      if (res.statusCode === 200) {
        getData(id);
        setShowMessage({
          message: res.message || 'Account Status changed successfully',
          messageType: 'success',
        });
      } else {
        setShowMessage({
          message: res.message || 'Account Status not changed',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
    } finally {
      setStatusLoading(false);
    }
  };

  const getData = async (id) => {
    try {
      setLoading(true);
      const res = await fetchAOwner(id);
      if (res.statusCode === 200) setData(res.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) getData(id);
    return () => {
      setData({});
    };
  }, [id]);

  const handleDeleteField = async (id) => {
    try {
      const res = await deleteBranch(id);
      if (res?.statusCode === 200) {
        const filteredData = data?.branch?.filter((branch) => branch?._id !== id);
        setData((pre) => ({ ...pre, branch: filteredData }));
        setShowMessage({
          message: res.message || 'Branch deleted Successfully',
          messageType: 'success',
        });
      } else {
        setShowMessage({
          message: res.message || 'Branch not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    }
  };

  const handleDetails = (id) => {
    naviage(`/branch/${id}`);
  };

  const handleUpdate = (item) => {
    setSelectedItemId(item._id);
    const { activeDuration, activeDurationType } = item;
    setUpdateFormData((pre) => ({
      ...pre,
      activeDuration,
      activeDurationType,
    }));
    setOpenDialogue(true);
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const hadleupdateData = async () => {
    setLoading(true);
    try {
      const res = await updateBranchSubscription(updateFormData, selectedItemId);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Branch Details updated successfully',
          messageType: 'success',
        });
        setData([]);
        getData(id);
      } else {
        setShowMessage({
          message: res.message | 'Branch details not Updated',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setLoading(false);
      setOpenDialogue(false);
    }
  };

  return (
    <PageContainer title="Owner Details" description="This is Owner Details Page">
      <DashboardCard2 title="Owner Details">
        {loading ? (
          <ShowLoader />
        ) : Object.keys(data).length === 0 ? (
          <div
            style={{
              width: '100%',
              textAlign: 'center',
              color: 'red',
              fontWeight: 'bold',
              fontSize: '18px',
            }}
          >
            No Data Found
          </div>
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  float: 'right',
                }}
              >
                {statusLoading ? (
                  <ShowLoader />
                ) : data.activeStatus && data.activeStatus.toLowerCase() === 'active' ? (
                  <button
                    style={{
                      backgroundColor: '#6174DD',
                      padding: '10px 15px',
                      color: '#fff',
                      borderRadius: '5px',
                      fontSize: '14px',
                      border: 'none',
                    }}
                    onClick={() => handleChangeStatus('INACTIVE')}
                  >
                    Deactivate Account
                  </button>
                ) : (
                  <button
                    style={{
                      backgroundColor: '#6174DD',
                      padding: '10px 15px',
                      color: '#fff',
                      borderRadius: '5px',
                      fontSize: '14px',
                      border: 'none',
                    }}
                    onClick={() => handleChangeStatus('ACTIVE')}
                  >
                    Activate Account
                  </button>
                )}
              </div>
              <div className="owner-container">
                <div className="owner-header">
                  <div className="profile-img">
                    <img
                      src={data?.logo ? data?.logo?.url : ProfileImg}
                      alt={data?.logo ? data?.logo?.url : ProfileImg}
                      style={{
                        height: '100%',
                        width: '100%',
                        borderRadius: '50%', // This property creates a circular border
                        objectFit: 'cover', // Ensures the image covers the entire container while maintaining its aspect ratio
                      }}
                    />
                  </div>
                  <div>
                    <p className="owner-text">Full Name : </p>
                    <h6 className="owner-bold-title">{data?.name}</h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="owner-body">
                      <p className="owner-text">Email : </p>
                      <h6 className="owner-title">{data?.email}</h6>
                    </div>
                    <div className="owner-body">
                      <p className="owner-text">Created Date : </p>
                      <h6 className="owner-title">{convertDateFormat(data?.createdAt)}</h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="owner-body">
                      <p className="owner-text">Mobile : </p>
                      <h6 className="owner-title">+91 {data?.phone}</h6>
                    </div>
                    <div className="owner-body">
                      <p className="owner-text">Address : </p>
                      <h6 className="owner-title">
                        {data?.ownerAddress?.address} {data?.address}
                      </h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="owner-body">
                      <p className="owner-text">Subscription Details : </p>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="owner-body">
                      <p className="owner-text">GST Number : </p>
                      <h6 className="owner-title">
                        {data?.gstNumber}
                      </h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="owner-body">
                      <p className="owner-text">Salon Opening Time : </p>
                      <h6 className="owner-title">
                        {formatTimeForDisplay(data?.salonOpeningTime)}
                      </h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="owner-body">
                      <p className="owner-text">Salon Closing Time : </p>
                      <h6 className="owner-title">
                        {formatTimeForDisplay(data?.salonClosingTime)}
                      </h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="owner-body">
                      <p className="owner-text">Start At : </p>
                      <h6 className="owner-title">{data?.subscriptionDetails?.startDate}</h6>
                    </div>
                    <div className="owner-body">
                      <p className="owner-text">End At : </p>
                      <h6 className="owner-title">{data?.subscriptionDetails?.endDate}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction="row"
                spacing={2}
                justifyContent="space-between"
                alignItems={'center'}
                mb={3}
                mt={5}
              >
                <Box>
                  <Typography variant="h4" fontSize={25}>
                    Branch List
                  </Typography>
                </Box>
              </Stack>
              <table className="table-container mt-2">
                <thead className="table-thead">
                  <tr>
                    {[
                      'Name',
                      'Email',
                      'Created Date',
                      'Status',
                      'Remaining Duration',
                      'Subscription Last Date',
                      'Message Sent',
                      'Actions',
                    ].map((h, index) => {
                      return (
                        <th key={index} style={{ width: '10%' }}>
                          {h}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody className="table-tbody">
            {data?.branch?.map((item) => {
                      return (
                      <tr key={item._id}>
                        <td
                          style={{
                            width: '10%',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                          }}
                        >
                          <Avatar
                            src={item?.logo ? item?.logo?.url : ProfileImg}
                            alt={item?.logo ? item?.logo?.url : ProfileImg}
                            sx={{
                              width: 30,
                              height: 30,
                            }}
                          />
                          {TrimData(item?.branchName)}
                        </td>
                        <td style={{ width: '10%' }}>{item?.branchEmail}</td>
                        <td style={{ width: '10%' }}>{convertDateFormat(item?.createdAt)}</td>
                        <td style={{ width: '10%' }}>{item?.activeStatus}</td>
                        <td style={{ width: '10%' }}>
                          {item?.remainingMonths > 1
                            ? `${item?.remainingMonths} months`
                            : `${item?.remainingMonths} month`}
                          {item?.remainingDays > 1 ? ` ${item?.remainingDays} days` : ` ${item?.remainingDays} day`}
                        </td>
                        <td style={{ width: '10%' }}>
                          {item?.subscriptionDetails?.duration?.endDate}
                        </td>
                        <td style={{ width: '10%' }}>{item?.sentSmsCount}</td>
                        <td style={{ width: '10%' }}>
                          <TableCells
                            type="button"
                            handleDeleteField={handleDeleteField}
                            handleUpdate={() => handleUpdate(item)}
                            handleDetails={handleDetails}
                            field={item?._id}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {/* ---------------------- Branch Details Dialog ---------------- */}
              <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
                <DialogTitle>Branch Details</DialogTitle>
                <DialogContent>
                  <DialogContentText>Here you can update Branch details.</DialogContentText>
                  {/* <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4}>
                        <TextInputs
                          title={'Branch Name'}
                          name={'branchName'}
                          value={updateFormData?.branchName}
                          handleChange={handleChange}
                          type={'text'}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextInputs
                          title={'Branch Email'}
                          name={'branchEmail'}
                          value={updateFormData?.branchEmail}
                          handleChange={handleChange}
                          type={'email'}
                          disabled={true}
                        />
                      </Grid>
                    </Grid>
                  </Box> */}
                  <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={8}>
                        <Grid container direction="row" spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextInputs
                              title={'Active Duration'}
                              name={'activeDuration'}
                              placeholder="0"
                              min={0}
                              value={updateFormData?.activeDuration}
                              handleChange={handleChange}
                              type={'number'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <SelectInputs
                              title={'Active Duration Type'}
                              name={'activeDurationType'}
                              value={updateFormData?.activeDurationType}
                              handleChange={handleChange}
                              options={activeDurationTypeMenuOptions}
                              optionTitle={'placeholder'}
                              optionValue={'value'}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </DialogContent>
                <DialogActions>
                  {loading ? (
                    <ShowLoader />
                  ) : (
                    <>
                      <div style={{ width: '200px', margin: '3rem auto' }}>
                        <Button
                          variant="contained"
                          fullWidth
                          color="primary"
                          target="_blank"
                          sx={{
                            background: '#6174DD',
                          }}
                          onClick={handleCloseDialogue}
                        >
                          Cancel
                        </Button>
                      </div>
                      <div style={{ width: '200px', margin: '3rem auto' }}>
                        <Button
                          variant="contained"
                          fullWidth
                          color="primary"
                          target="_blank"
                          sx={{
                            background: '#6174DD',
                          }}
                          onClick={hadleupdateData}
                        >
                          update
                        </Button>
                      </div>
                    </>
                  )}
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        )}
      </DashboardCard2>
    </PageContainer>
  );
};

export default OwnerDetails;

function convertDateFormat(createdAt) {
  // Create a Date object from the provided string
  const dateObject = new Date(createdAt);

  // Get day, month, and year
  const day = String(dateObject.getUTCDate()).padStart(2, '0');
  const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0');
  const year = dateObject.getUTCFullYear();

  // Combine into the desired format
  const formattedDate = `${day}-${month}-${year}`;

  return formattedDate;
}

function formatTimeForDisplay(timeString) {
  if (!timeString) return '';

  const [hours, minutes] = timeString.split(':').map(Number);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

  return `${formattedHours}:${String(minutes).padStart(2, '0')} ${ampm}`;
}

